module.exports = __webpack_public_path__ + "static/media/graph-5.8a76dcef.svg";